module.exports = __webpack_public_path__ + "img/copy.4d964303.svg";